import React, { useState, useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import Axios from "axios"
import SearchResults from './SearchResults';
import useSubscriptionDetails from '../hooks/useSubscriptionDetails';
//import Shimmer from './Shimmer';
import { useAuth } from './AuthContext'; // Import the AuthContext
import SidebarLayout from './SidebarLayout';
import chatgpt from '../assets/chatgpt.png';

import llama from '../assets/llama.png';
import claude from '../assets/claude.png';
import mistral from '../assets/mistral.png';
import gemini from '../assets/gemini.png';


function SearchForm() {

    const { user, loading } = useAuth(); // Access the user and loading state from AuthContext
    const [textareaValue, setTextareaValue] = useState('');
    const [isButtonEnabled, setIsButtonEnabled] = useState(false);
    const [responseData, setResponseData] = useState('');
    const responseDataRef = useRef("");
    const [isLoading, setIsLoading] = useState(false);
    const [searchResultFor, setSearchResultFor] = useState('');
    const [isStreaming, setIsStreaming] = useState(true);
    const [userData, setUserData] = useState('');
    const [userId, setUserId] = useState('');
    const [userEemail, setUserEemail] = useState('');
    const [isExpanded, setIsExpanded] = useState(false); // State to control sidebar
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const chatId = queryParams.get("chat_id"); // ✅ Get chat_id from query
    const [showDropdown, setShowDropdown] = useState(false);
    const dropdownRef = useRef(null);

    const { subscriptionDetails } = useSubscriptionDetails(user);

    //console.log(chatId);

    // Array of content values
    const suggestions = [
        'Tell me about Cavan Sullivan.',
        'Show me MLS Next All Star Youth Ballers.',
        'Show me the most viewed youth player on GoldCleats.',
        'Can you show me "verified" players from the community?',
    ];

    useEffect(() => {
        document.addEventListener('DOMContentLoaded', () => {
            const listItems = document.querySelectorAll('.sources ul li'); // All list items
            const visibleCount = 3; // Number of items to display initially
            const moreIndicator = document.querySelector('.more-indicator'); // More indicator element

            // Hide all list items initially
            listItems.forEach((item, index) => {
                if (index >= visibleCount) {
                    item.style.display = 'none'; // Hide items beyond the visible count
                }
            });

            // Calculate hidden items count
            const hiddenCount = listItems.length - visibleCount;

            // Update the More indicator text dynamically
            if (hiddenCount > 0) {
                moreIndicator.textContent = `+${hiddenCount} More`;

                // Add click event to reveal hidden items
                moreIndicator.addEventListener('click', () => {
                    listItems.forEach(item => {
                        item.style.display = 'block'; // Display all items
                    });
                    moreIndicator.style.display = 'none'; // Hide the More indicator after expanding
                });
            } else {
                moreIndicator.style.display = 'none'; // Hide the indicator if no hidden items
            }
        });
    }, []);




    useEffect(() => {
        if (user && user.uid) {
            const user_id = user.uid; // Extract user_id from Firebase user object
            setUserId(user_id);
            setUserEemail(user.email)
        }

    }, [user]);
    //console.log(JSON.stringify(user));


    const handleApplyFilters = async (e, content) => {
        e.preventDefault();
        setResponseData('');
        setSearchResultFor('')
        setUserData('')

        const inputContent = (typeof content !== 'undefined') ? content : textareaValue

        // const trimmedValue = textareaValue.trim();

        // console.log("trimmedValue==", trimmedValue)

        if (inputContent === '') {
            // Handle empty input, button remains disabled
            return;
        }

        const API_URL = process.env.REACT_APP_BACKENDURL;

        const url = new URL(API_URL);
        url.searchParams.append('request', 'publicSearchDataAi');
        url.searchParams.append('action', 'searchDataAiStream');
        url.searchParams.append('search_query', inputContent);
        url.searchParams.append('user_id', userId);
        url.searchParams.append('fuid', userId);
        url.searchParams.append('email', userEemail);

        //console.log(formData);

        setIsLoading(true);

        // setTimeout(() => {
        //     usersData(e, inputContent);
        // }, 3000); // 3 seconds delay

        const eventSource = new EventSource(url);

        eventSource.onmessage = (event) => {
            //console.log('Raw event data:', event.data);

            try {

                if (event.data === '[DONE]') {
                    setIsLoading(false);
                    setTextareaValue('')
                    setSearchResultFor(inputContent)
                    setIsStreaming(false);
                    // Call the usersData API after streaming response stops
                    // 🔹 Use `responseDataRef.current` for the latest data
                    usersData(e, inputContent, responseDataRef.current);

                    eventSource.close();
                    return
                }

                const parsedData = JSON.parse(event.data);

                if (parsedData.choices && parsedData.choices.length > 0) {
                    const choice = parsedData.choices[0];
                    const newContent = choice.delta?.content || '';
                    setResponseData(prevContent => prevContent + newContent);
                    // 🔹 Update `responseDataRef.current` (stores the latest value instantly)
                    responseDataRef.current += newContent;
                }


            } catch (error) {
                console.error('Error parsing SSE data:', error);

                setIsLoading(false);
            }
        };

        eventSource.onerror = (event) => {
            setIsStreaming(false);
            setIsLoading(false);
            console.error('EventSource failed:', event);
            eventSource.close();

        };

        return () => {
            eventSource.close();
        };
    };


    const usersData = async (e, content, responseData) => {
        e.preventDefault();
        setTextareaValue('')

        const inputContent = (typeof content !== 'undefined') ? content : textareaValue

        setSearchResultFor(inputContent)

        if (inputContent === '') {
            // Handle empty input, button remains disabled
            return;
        }

        const chatId = generateChatId();

        // Create a new FormData object
        const formData = new FormData();
        formData.append('request', 'publicSearchAi');
        formData.append('action', 'searchDataAi');
        formData.append('search_query', inputContent);
        formData.append('user_id', userId);
        formData.append('fuid', userId);
        formData.append('email', userEemail);
        formData.append('chat_id', chatId);
        // Convert responseData (HTML) to a JSON string
        formData.append('response_data', JSON.stringify({ html: responseData }));

        //console.log(formData);

        setIsLoading(true);

        const URL = process.env.REACT_APP_BACKENDURL;

        // Send the POST request using Axios
        Axios.post(URL, formData, {
            headers: {
                'Content-Type': 'multipart/form-data', // Important for FormData
            },
            withCredentials: true, // Include credentials (cookies) if necessary
        })
            .then(response => {
                // Handle success
                console.log(response.data);
                setIsLoading(false);
                setUserData(response.data);
            })
            .catch(error => {
                // Handle error
                // Clear loading message after API request is complete
                //setLoadingMessage('');
                setIsLoading(false);
                console.error('Error:', error);
            });


    };


    useEffect(() => {
        if (!chatId) return; // ✅ Prevent API call if chat_id is missing

        const fetchChatData = async () => {
            try {
                // ✅ Create FormData object
                const formData = new FormData();
                formData.append("request", "fetchChatData");
                formData.append("action", "getChatHistory");
                formData.append("chat_id", chatId); // ✅ Append chat_id

                // ✅ Send FormData in Axios POST request
                const response = await Axios.post(process.env.REACT_APP_BACKENDURL, formData, {
                    headers: {
                        "Content-Type": "multipart/form-data", // ✅ Important for FormData
                    },
                });

                if (response.status === 200 && response.data) {
                    setResponseData(response.data.data.search_response); // ✅ Store data in state
                    setUserData(JSON.parse(response.data.data.users_data))
                } else {
                    throw new Error("No data found");
                }
            } catch (err) {
                console.error("Error fetching chat data:", err);
            }
        };

        fetchChatData();
    }, [chatId]);


    // Function to generate a secure chat ID (equivalent to PHP's bin2hex(random_bytes(16)))
    const generateChatId = () => {
        const array = new Uint8Array(16);
        window.crypto.getRandomValues(array);
        return Array.from(array, byte => byte.toString(16).padStart(2, '0')).join('');
    };


    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault(); // Prevent the default behavior of adding a new line
            handleApplyFilters(e); // Trigger form submission
        }
    };

    const handleChange = (e) => {
        const value = e.target.value;
        setTextareaValue(value);
        setIsButtonEnabled(value.trim() !== '');
    };


    // Handle suggestion click event
    const handleClick = (event, content) => {
        event.preventDefault(); // Prevent the default anchor tag behavior     
        //isLoading
        if (isLoading) {
            console.log('Request already in progress. Please wait.');
            return;
        }
        console.log('Content:', content);
        setTextareaValue(content);
        handleApplyFilters(event, content); // Send content to the server
    };

    // Close dropdown on outside click
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setShowDropdown(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    const llmModels = [
        { name: "OpenAI GPT-5", logo: chatgpt, enabled: true },
        { name: "Claude 3", logo: claude, enabled: false },
        { name: "Gemini", logo: gemini, enabled: false },
        { name: "Mistral", logo: mistral, enabled: false },
        { name: "LLaMA 3", logo: llama, enabled: false },
        { name: "Playeragent.ai", logo: "🕵️", enabled: false },
        { name: "Playerscout.ai", logo: "🔍", enabled: false },
        { name: "Playermanager.ai", logo: "📋", enabled: false }
    ];

    // { name: "playeragent.ai", logo: gemini }, 
    // { name: "playerscout.ai", logo: gemini }, 
    // { name: "playermanager.ai", logo: gemini } 


    return (
        <>
            <SidebarLayout isExpanded={isExpanded} setIsExpanded={setIsExpanded} userId={userId} />
            <div className={`searchResultFor ${isExpanded ? "expanded-search-mobile" : ""}`} style={{ color: '#EEEEF0' }}>
                <div className="row justify-content-center">
                    <div className="col-12 col-md-6">
                        <div className="d-flex justify-content-center align-items-center bg-light">
                            <div className="container text-center">
                                <h1>Smart Soccer Search Powered by AI</h1>

                                <form onSubmit={handleApplyFilters} className='search-form'>
                                    {/* Dropdown for LLM models */}
                                    <div className="dropdown mb-3" ref={dropdownRef}>
                                        <button
                                            type="button"
                                            className="btn btn-login dropdown-toggle"
                                            onClick={() => setShowDropdown(!showDropdown)}
                                        >
                                            OpenAI GPT-5
                                        </button>
                                        {showDropdown && (
                                            <ul className="dropdown-menu show p-2" style={{ minWidth: "220px" }}>
                                                {llmModels.map((model, index) => (
                                                    <li key={index}
                                                        className={`dropdown-item d-flex align-items-center ${!model.enabled ? 'disabled' : ''}`}
                                                        style={{ opacity: model.enabled ? 1 : 0.5, pointerEvents: model.enabled ? "auto" : "none" }}
                                                    >
                                                        {typeof model.logo === "string" && model.logo.length > 10 ? (
                                                            <img src={model.logo} alt={model.name} className="me-2 model-img" />
                                                        ) : (
                                                            <span className="me-2" style={{ fontSize: "20px" }}>{model.logo}</span>
                                                        )}
                                                        {model.name}
                                                        {!model.enabled && (
                                                            <span className="text-muted" style={{ fontSize: "10px", marginLeft: "5px" }}>
                                                                Coming Soon
                                                            </span>
                                                        )}
                                                    </li>
                                                ))}
                                            </ul>
                                        )}
                                    </div>
                                    <div className="search-bar form-group d-flex align-items-center justify-content-center">

                                        <div className="input-group">
                                            <textarea
                                                className="form-control textarea-with-button"
                                                id="textarea"
                                                rows="1"
                                                placeholder="Search for soccer players, teams, or matches..."
                                                value={textareaValue}
                                                onChange={handleChange}
                                                onKeyDown={handleKeyDown}
                                            ></textarea>
                                            <button
                                                className={`btn ${textareaValue ? 'btn-primary' : 'btn-disabled'} button-inside-textarea`}
                                                type="submit"
                                                disabled={!textareaValue || isLoading}
                                            >

                                                {isLoading ? (
                                                    <div className="spinner-grow spinner-grow-sm" role="status">
                                                    </div> // Show square box while loading
                                                ) : (
                                                    <i className="fa fa-arrow-right arrow-color"></i> // Arrow icon when not loading
                                                )}

                                                {/* <i className="fa fa-arrow-right arrow-color"></i> */}
                                            </button>
                                        </div>



                                    </div>
                                </form>
                                <div className="row suggestions">
                                    {suggestions.map((content, index) => (
                                        <div className="col-md-6 mb-3" key={index}>
                                            <div className="bg-dark text-white card">
                                                <div className="card-body">
                                                    <a
                                                        href="#"
                                                        className="text-decoration-none text-dark"
                                                        onClick={(event) => handleClick(event, content)}
                                                    >
                                                        <span className="font-medium text-sm">{content}</span>
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                    {/* <div className="col-md-6 padding-0">
                                    <a href="#" className="card text-decoration-none text-dark">
                                        <div className="">
                                            
                                            <span className="font-medium text-sm">Bootroom: Soccer Blog Posts and Insights</span>
                                        </div>
                                    </a>
                                </div>
                                <div className="col-md-6 padding-0">
                                    <a href="#" className="card text-decoration-none text-dark">
                                        <div className="">
                                           
                                            <span className=" font-medium text-sm">Best </span>
                                        </div>
                                    </a>
                                </div> */}
                                </div>



                            </div>
                        </div>


                    </div>
                </div>


                {searchResultFor &&
                    <div className={`searchResultFor ${isExpanded ? "expanded-search" : ""}`}><h3>{searchResultFor}</h3></div>
                }

                {!subscriptionDetails && !searchResultFor &&
                    <div className='no-subs'>You must have an active subscription to use this feature. Please visit the&nbsp; <a href="/pricing">pricing page</a> &nbsp;to activate your subscription.</div>
                }


                <div className={`search-results ${isExpanded ? "expanded-search" : ""}`} style={{ color: '#EEEEF0' }}>
                    <div className="row mt-2">
                        <div className={`col-md-8`}>
                            <div className="content-display">
                                <div dangerouslySetInnerHTML={{ __html: responseData }}></div>
                            </div>
                            {/* {isLoading && (
                            <Shimmer />
                        )} */}
                            {userData && userData.data && userData.data.suggested_users && userData.data.suggested_users.length > 0 && (
                                <div className="suggested-players-container">
                                    <strong>🔍 You May Also Like</strong>
                                    <div className="suggested-players">
                                        {userData.data.suggested_users.map((player, index) => (
                                            <div className="player-tag" key={player.ID} onClick={(event) => handleClick(event, `Tell me about ${player.user_fname} ${player.user_lname}`)}>
                                                <span>{player.user_fname} {player.user_lname} </span>
                                                {player.user_nationality && <img src={`/32/${player.user_nationality}.png`} alt={`${player.user_nationality}`} style={{ width: '20px', height: '15px', marginLeft: '2px' }} />}
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            )}
                        </div>
                        <div className="col-md-4">
                            {/* {isLoading && (
                            <Shimmer />
                        )} */}
                            {userData &&
                                <SearchResults onTagClick={handleClick} responseData={userData} />
                            }
                        </div>

                    </div>
                </div>

                {/* <SearchResults onTagClick={handleClick} responseData={responseData} /> */}

            </div>
        </>
    );
}



export default SearchForm;
